import { serviceCardContent } from "../data";
import { Rule } from "sanity";

const initialServices = serviceCardContent.map(service => ({
    title: service.heading,
    description: service.body
}));

export default {
    name: 'ourServicesId',
    title: 'Our Services Page',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            validation: Rule => Rule.required(),
            initialValue: 'OUR SERVICES'
        },
        {
            name: 'subtitle',
            title: 'Subtitle',
            type: 'string',
            initialValue: 'Bansah & Associates - Areas of Specialization'
        },
        {
            name: 'description',
            title: 'Description',
            type: 'text',
            initialValue: `At Bansah & Associates, we specialize in expert immigration
                services, helping individuals, families, and businesses navigate
                the complexities of Canadian immigration. Whether you're seeking
                permanent residency, work permits, refugee claim or any of the
                services below, our dedicated team provides personalized
                guidance and strategic solutions. With in-depth knowledge of
                immigration laws and policies, we are committed to making your
                journey to Canada smooth and successful. Let us handle the
                details while you focus on your future.`
        },
        {
            name: 'services',
            title: 'Services',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'title',
                            title: 'Title',
                            type: 'string'
                        },
                        {
                            name: 'description',
                            title: 'Description',
                            type: 'text'
                        },
                        {
                            name: 'image',
                            title: 'Image',
                            type: 'image',
                            options: {
                                hotspot: true
                            }
                        }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: initialServices
        }
    ],
    preview: {
        select: {
            title: 'title'
        },
        prepare({ title }) {
            return {
                title: 'Our Services',
                subtitle: title
            }
        }
    }
} 